import L from 'leaflet';

export const PLACEMENT_LABELS = {
    home_header: 'أعلى الصفحة الرئيسية',
    destination: 'شاشة اختيار الوجهة (قديم)',
    waiting_offers: 'شاشة انتظار العروض',
    featured_listing: 'ورشة موثوقة (أولوية الظهور)',
};

// The three forms a package is sold for. Header and waiting have a fixed number of spots.
export const AD_FORMS = [
    { value: 'home_header', label: 'أعلى الصفحة الرئيسية', hint: 'بانر في أعلى الشاشة الرئيسية للمستخدمين والسائقين', limited: true },
    { value: 'waiting_offers', label: 'شاشة انتظار العروض', hint: 'يظهر أثناء انتظار العروض (للمستخدم) وانتظار قبول العرض (للسائق)', limited: true },
    { value: 'featured_listing', label: 'ورشة موثوقة', hint: 'شارة "موثوق" وأولوية في قائمة الوجهات ودليل الورش - بدون حد', limited: false },
];

export const DURATION_PRESETS = [
    { days: 30, label: 'شهر' },
    { days: 180, label: '6 أشهر' },
    { days: 365, label: 'سنة' },
];

export const SHOP_STATUS = {
    pending: { label: 'قيد المراجعة', tone: 'warning' },
    approved: { label: 'معتمدة', tone: 'success' },
    rejected: { label: 'مرفوضة', tone: 'danger' },
    suspended: { label: 'موقوفة', tone: 'muted' },
};

export const AD_STATUS = {
    pending: { label: 'بانتظار الموافقة', tone: 'warning' },
    scheduled: { label: 'مجدول', tone: 'info' },
    active: { label: 'نشط', tone: 'success' },
    expired: { label: 'منتهي', tone: 'muted' },
    rejected: { label: 'مرفوض', tone: 'danger' },
    cancelled: { label: 'ملغي', tone: 'muted' },
};

export const DAY_NAMES = ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'];

export const markerIcon = new L.Icon({
    iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
    iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
    shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    shadowSize: [41, 41],
});

const moneyFormat = new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 });
export const formatMoney = (amount) => `${moneyFormat.format(Number(amount) || 0)} د.ل`;
export const formatNumber = (n) => moneyFormat.format(Number(n) || 0);

export const formatDate = (value, withTime = false) => {
    if (!value) return '—';
    return new Date(value).toLocaleString('ar-LY', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        ...(withTime ? { hour: '2-digit', minute: '2-digit' } : {}),
    });
};

export const StatusChip = ({ status, map = SHOP_STATUS }) => {
    const info = map[status] || { label: status, tone: 'muted' };
    return <span className={`status-chip tone-${info.tone}`}>{info.label}</span>;
};

export const hoursText = (entry) => (entry?.isClosed ? 'مغلق' : `${entry?.open || '--'} - ${entry?.close || '--'}`);
